import React, { useEffect } from 'react';
import { useUIStore } from '../store';
import { X, CheckCircle, AlertCircle, Info } from 'lucide-react';

export default function ToastContainer() {
  const { toasts, removeToast } = useUIStore();

  return (
    <div className="fixed bottom-4 right-4 z-[200] flex flex-col gap-2">
      {toasts.map(toast => (
        <Toast key={toast.id} toast={toast} onClose={() => removeToast(toast.id)} />
      ))}
    </div>
  );
}

function Toast({ toast, onClose }) {
  useEffect(() => {
    const timer = setTimeout(onClose, toast.duration || 3000);
    return () => clearTimeout(timer);
  }, []);

  const icons = { success: CheckCircle, error: AlertCircle, info: Info };
  const colors = {
    success: 'border-green-500/50 bg-green-500/10 text-green-500',
    error: 'border-red-500/50 bg-red-500/10 text-red-500',
    info: 'border-blue-500/50 bg-blue-500/10 text-blue-500'
  };
  const Icon = icons[toast.type] || Info;

  return (
    <div className={`flex items-center gap-3 px-4 py-3 rounded-lg border shadow-lg animate-in slide-in-from-right ${colors[toast.type] || colors.info}`}>
      <Icon size={16} />
      <span className="text-sm font-medium">{toast.title}</span>
      {toast.description && <span className="text-sm opacity-70">{toast.description}</span>}
      <button onClick={onClose} className="ml-2 opacity-50 hover:opacity-100"><X size={14} /></button>
    </div>
  );
}
